import { ProForm } from '@ant-design/pro-components'
import { type ReactNode, useId } from 'react'
import { DateSearchInput, type DateSearchInputProps, type DateSearchValue } from '../components/DateSearchInput'
import { EditableLabel } from '../components/EditableLabel'
import { EditableShell } from '../components/EditableShell'
import { useFieldContext } from '../createAppFormHook'
import { useEditableFieldMode } from '../hooks/useEditableFieldMode'

export type DateSearchInputFieldProps = Omit<DateSearchInputProps, 'value' | 'onChange'> & {
  label?: ReactNode
  required?: boolean
}

export function DateSearchInputField(props: DateSearchInputFieldProps) {
  const { label, required, className, ...inputProps } = props
  const fieldCtx = useFieldContext<DateSearchValue | undefined>()
  const editable = useEditableFieldMode<DateSearchValue | undefined>()
  const generatedId = useId()
  const id = inputProps.id ?? generatedId

  const value = fieldCtx.state.value ?? null

  return (
    <EditableShell
      mode={editable.mode}
      enterEdit={editable.enterEdit}
      exitRead={editable.exitRead}
      className={className}
    >
      <ProForm.Item
        label={
          label && (
            <EditableLabel
              mode={editable.mode}
              enterEdit={editable.enterEdit}
              exitRead={editable.exitRead}
              onUndo={editable.undoAndExit}
              canUndo={editable.canUndo}
            >
              {label}
            </EditableLabel>
          )
        }
        htmlFor={id}
        required={required}
      >
        <DateSearchInput
          {...inputProps}
          id={id}
          value={value}
          onChange={next => fieldCtx.handleChange(next ?? undefined)}
          disabled={editable.mode === 'read'}
          allowClear={!required}
        />
      </ProForm.Item>
    </EditableShell>
  )
}
